import { AvatarProps, default as MuiAvatar } from '@mui/material/Avatar'
import * as React from 'react'
import AvatarIcon from '@eversports/design-tokens/assets/icons/avatar.svg'

export const Avatar: React.FC<React.PropsWithChildren<AvatarProps>> = ({ src, sx, ...props }) => {
  // If there's a child component to render
  if (props.children) {
    return (
      <MuiAvatar
        {...props}
        sx={{
          backgroundColor: 'lightgray',
          color: 'darkgray',
          width: 24,
          height: 24,
          textTransform: 'uppercase',
          padding: src ? 0 : 1,
          '> img': {
            objectFit: src ? 'cover' : 'contain',
          },
          ...sx,
        }}
      >
        {props.children}
      </MuiAvatar>
    )
  }

  // If there's no image, but we have the alt text (assuming the first initial), use the first character
  // https://mui.com/material-ui/react-avatar/#fallbacks
  if (!src && props.alt) {
    return (
      <MuiAvatar
        {...props}
        sx={{
          backgroundColor: 'lightgray',
          color: 'darkgray',
          width: 24,
          height: 24,
          textTransform: 'uppercase',
          padding: src ? 0 : 1,
          '> img': {
            objectFit: src ? 'cover' : 'contain',
          },
          ...sx,
        }}
      >
        {props.alt.charAt(0)}
      </MuiAvatar>
    )
  }

  // Render the image. If MUI sees it's broken, it will try to render the first character of the alt text - last backup is a generic avatar
  return (
    <MuiAvatar
      {...props}
      src={src || AvatarIcon}
      sx={{
        backgroundColor: 'lightgray',
        color: 'darkgray',
        width: 24,
        height: 24,
        textTransform: 'uppercase',
        padding: src ? 0 : 1,
        '> img': {
          objectFit: src ? 'cover' : 'contain',
        },
        ...sx,
      }}
    />
  )
}

export default Avatar
